var LinksApp = angular.module('LinksApp', ['ui.bootstrap', 'ui.tree', 'ui.select',  'ngFileUpload', 'angularSoundManager', 'LinkCollectionFactory', 'LinkFactory', 'PleaseWaitModal', 'ConfirmationModal', 'ProgressModal']);

LinksApp.filter('urlencode', function() {
    return window.encodeURIComponent;
});

SiteApp.requires.push('LinksApp');